import { Box } from 'components/base';
import { GoogleMap } from 'components/atoms';
import { FC } from 'react';
import { ICoordinate } from 'types/map';

interface IPreviewMapProps {
  location?: ICoordinate;
  onMapClick?: (lat: number, lng: number) => void;
}

const PreviewMap: FC<IPreviewMapProps> = ({ location, onMapClick }) => (
  <Box sx={{ height: '400px', width: '100%' }}>
    <GoogleMap
      location={location}
      zoom={15}
      canClickMap
      showMarker={!!location}
      onMarkerDragEnd={onMapClick}
      onMapClick={onMapClick}
    />
  </Box>
);

export default PreviewMap;
